import * as React from 'react';
import { ReactNode } from 'react';

import { BinIcon } from '../../Icons';
import { SpinnerV2 } from '../../SpinnerV2';

interface IProps {
  additionalClass?: string;
  autoFocus?: boolean;
  file: Object;
  id?: any;
  inputTextType?: any;
  isDisabled?: boolean;
  isFocused: boolean;
  isLoading: boolean;
  name?: string;
  onChange?: (name: string, value: any, file?: any, removeFile?: any) => void;
  placeholder: string;
  readOnly?: boolean;
  type: string;
  value?: string[] | string | number;
  sizeNoteText?: string | ReactNode;
  noFileErrorText?: string | ReactNode;
}

interface IState {
  isFocused: boolean;
  fileName: string;
}

class InputFile extends React.Component<IProps, IState> {
  private inputRef: HTMLInputElement;
  private focusTimeoutId;

  constructor(props: any) {
    super(props);
    this.state = {
      isFocused: false,
      fileName: this.props.file ? this.props.file['fileName'] : null,
    };
  }

  public componentDidMount() {
    this.focusTimeoutId = setTimeout(() => {
      if (this.props.isFocused) {
        this.inputRef.focus();
      }
    }, 0);
  }

  public componentWillUnmount() {
    clearTimeout(this.focusTimeoutId);
  }

  public render() {
    const { name, type, isFocused, isLoading, isDisabled, readOnly, file, id } = this.props;

    const { fileName } = this.state;

    return (
      <div style={{ display: 'flex' }}>
        {isLoading && (
          <div className='inputSpinner'>
            <SpinnerV2 relative />
          </div>
        )}

        {!fileName && <span className='sizeNote'>{this.props.sizeNoteText}</span>}

        {fileName && (
          <span className={`${'inputFileName'} ${fileName && 'hasFile'}`}>
            {file && file['type'].includes('video') && (
              <video poster={file['type']} controls>
                <source src={file['url']} type={file['type']} />
              </video>
            )}

            {file && file['url'] && !file['type'].includes('video') && <img src={file['url']} alt='Uploaded file' />}

            <p className={'inputFileText'}>{fileName ? fileName : this.props.noFileErrorText}</p>

            <button onClick={this.removeFile}>
              <BinIcon />
            </button>
          </span>
        )}

        <label htmlFor={id} className={'inputFileWrapper'}>
          <span className={'inputFileButton'}>Datei auswählen</span>

          <input
            id={id}
            name={name}
            type={type}
            readOnly={readOnly}
            onChange={this.handleChange}
            className={'inputFile'}
            ref={(input) => isFocused && (this.inputRef = input)}
            autoFocus={isFocused}
            disabled={isDisabled || isLoading}
            autoComplete='off'
          />
        </label>
      </div>
    );
  }

  private handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.currentTarget.name;
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;

    this.setState({ fileName: file ? file.name : '' });
    this.props.onChange && this.props.onChange(name, file.name, file, this.removeFile);
  };

  private removeFile = () => {
    this.props.onChange && this.props.onChange('remove', this.state.fileName, null);
    this.inputRef.value = '';
    this.setState({ fileName: '' });
  };
}

export default InputFile;
